module.exports = __webpack_public_path__ + "static/media/Fichier 21.7089c9d1.svg";